export default __webpack_public_path__ + "images/12e12fe8dddec6843a9de0d0a10fb0ab-experimental.webp";